<template>
    <PButton title="Подписать документ" @click="openWiz()"/>
    <div class="doc-list">
      <doc-preview-component v-if="hasPhone && loadRes"/>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import PButton from '../components/ui/PButton.vue';
import { state } from '@/store/state';
import DocPreviewComponent from '@/components/blocks/DocPreviewComponent.vue';

export default defineComponent({
  name: 'MainView',
  components: {PButton, DocPreviewComponent},
  setup(){
    const loadRes = ref<boolean>(false)
    onMounted(async () => {
      loadRes.value = await LoadAwaitFinc();
      if(!loadRes.value){
        alert('Для работы приложения необходимо добавить api-ключ в настройках');
        return;
      }
    })

    const LoadAwaitFinc = (): Promise<boolean> => {
      return new Promise((resolve, reject) => {
        let i = 0;
        const interval = setInterval(()=>{
          if(state.apiKey?.length){
            clearInterval(interval)
            resolve(true)
            return;
          } else if(i > 9){
            clearInterval(interval)
            reject(false)
          }
          i++;
        }, 500)
      })
    }

    const hasPhone = computed(()=> !!state.client?.phone)

    return {hasPhone, loadRes}
  },
  methods:{
    openWiz(){
        state.route = 'WizardView'
    },
  }
});
</script>

<style scoped>
.doc-list{
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}
</style>